import http from '@/utils/http'

const auth = (body) => http.post('/login', body)

export const updateUser = (id, body) => http.put(`/users/${id}`, body)

export const loadApis = (params = {}) => http.get('/apis', { params })

export default auth
